// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "time_entry".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { timeEntrySourceValues, timeEntryStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "time_entry" table (1:1 with a DB row, on the wire). */
export const timeEntryAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    practitionerId: z.string(),
    clockIn: z.string().datetime(),
    clockOut: z.string().datetime().nullable(),
    source: z.enum(timeEntrySourceValues),
    status: z.enum(timeEntryStatusValues),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=timeEntry.js.map